import React, { CSSProperties } from "react";
import Title from "common/Typography/Title";
import Tooltip from "common/Tooltips/Tooltip";

interface SubGroupNameProps {
  name: string;
  level: number;
  style?: CSSProperties;
}

const GroupName = ({ name, level, style }: SubGroupNameProps) => {
  return (
    <Tooltip title={name} placement="topLeft" style={{ overflow: "hidden" }}>
      <Title
        level={level}
        style={{ paddingRight: 8, ...style }}
        $ellipsis={true}
      >
        {name}
      </Title>
    </Tooltip>
  );
};

export default GroupName;
